import type { AbstractControl } from '@angular/forms';
import { isEqual } from 'lodash-es';
import { defer, distinctUntilChanged, map, startWith, type Observable } from 'rxjs';

export function observeControlValue$<T extends AbstractControl<any>>(control: T): Observable<ReturnType<T['getRawValue']>> {
    return defer(() => {
        return control.valueChanges.pipe(
            map(() => control.getRawValue()),
            startWith(control.getRawValue())
        );
    });
}

export function observeControlValidity$(control: AbstractControl<any>): Observable<boolean> {
    return defer(() => {
        return control.statusChanges.pipe(
            startWith(control.status),
            map((status: 'VALID' | 'INVALID' | 'PENDING' | 'DISABLED') => status === 'VALID' || status === 'DISABLED')
        );
    });
}

export function observeControlErrors$(control: AbstractControl<any>): Observable<{ [errorCode: string]: any }> {
    return observeControlValue$(control).pipe(
        map(() => control.errors || {}),
        distinctUntilChanged(isEqual)
    );
}
